<template>
  <div id="admin">
    <Menubar>
    <template #start>
        <img alt="logo" src="../assets/img/fav/Icon.png" height="40" class="p-mr-2">
    </template>
    <template #end>
        <Button type="button" label="Мэдэгдэл" icon="pi pi-envelope" class="p-button-warning" badge="2" badgeClass="p-badge-info" :style="{'margin-right': '1.0em'}" @click="toggle"/>
        <Button label="Гарах" icon="pi pi-sign-out" :style="{'margin-left': '0 .5em'}" @click="logOut()" v-tooltip="'Системээс гарах'"/>
    </template>
    </Menubar>
    <div class="p-grid"> 
      <div class="p-col-fixed" style="width: 200px">
          <Menu :model="items" />
      </div>
      <div class="p-col">
        <div class="p-shadow-14">
          <router-view />
        </div>
      </div>
    </div>

    <OverlayPanel ref="op" :showCloseIcon="true"  appendTo="body" style="width: 350px">
      <DataTable :value="notificationData" selectionMode="single" :paginator="true" :rows="5">
        <Column field="Title" header="Гарчиг" sortable></Column>
        <Column field="Desctiption" header="Мэдээлэл"></Column>
      </DataTable>
    </OverlayPanel>

  </div>
</template>

<script>
import Menu from "primevue/menu";
import Menubar from 'primevue/menubar';
import Button from 'primevue/button';
import OverlayPanel from 'primevue/overlaypanel';
import DataTable from "primevue/datatable";
import Column from "primevue/column";

export default {
  name: "admin",
  computed:{
     loggedIn(){
       return this.$store.getters.loggedIn
     }
  },
  components: {
    Menu,
    Menubar,
    Button,
    OverlayPanel,
    DataTable,
    Column
  },
  data() {
    return {
      notificationData: [
        {Title: "Төлбөр", Desctiption: "Төлбөр хийгдсэн"}
        , {Title: "Лизиг", Desctiption: "Хугацаа хэтэрсэн"}
         ],
      items: [
        {
          label: "Төлбөр тоцоо",
          icon: "pi pi-fw pi-dollar",
          items: [
            {
              label: "Нэхэмжлэх бүртгэл",
              icon: "pi pi-fw pi-money-bill",
              to: "/Invoice",
            }         
          ],
        },
        {
          label: "Бүртгэл",
          icon: "pi pi-fw pi-file",
          items: [
            {
              label: "Хэрэглэгчийн бүртгэл",
              icon: "pi pi-fw pi-user-plus",
              to: "/User",
            },
            { label: "Гэрээ бүртгэл", 
              icon: "pi pi-fw pi-home", 
              to: "/Contract" },
            {
              label: "Багцын бүртгэл",
              icon: "pi pi-fw pi-inbox",
              to: "/Package",
            },
            {
              label: "Бүтээгдэхүүний бүртгэл",
              icon: "pi pi-fw pi-android",
              to: "/Product",
            },
            {
              label: "Үйлчилгээний бүртгэл",
              icon: "pi pi-fw pi-thumbs-up",
              to: "/OrderService",
            },         
          ],
        },
      ],

    };
  },
  methods:{
    logOut(){
        this.$store.dispatch("destroyToken");
        this.$router.push('login');
    },
    toggle(event) {
    this.$refs.op.toggle(event);
    }  
  }
};
</script>